import * as Headless from '@headlessui/react'
import React from 'react'
import clsx from 'clsx'

export function Checkbox({ className, ...props }) {
  return (
    <Headless.Checkbox
      data-slot="control"
      className={clsx(
        className,
        'group relative isolate flex size-[1.125rem] items-center justify-center rounded-[0.3125rem] sm:size-4',
        'outline-none data-[focus]:outline data-[focus]:outline-2 data-[focus]:outline-offset-2 data-[focus]:outline-blue-500',
        'data-[checked]:bg-blue-500 data-[checked]:data-[hover]:bg-blue-600',
        'data-[disabled]:opacity-50',
        'bg-white shadow ring-1 ring-black/5 data-[hover]:bg-gray-50'
      )}
      {...props}
    >
      <svg
        className="pointer-events-none size-4 self-center fill-white group-data-[checked]:opacity-100 opacity-0 forced-colors:block"
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.416 3.376a.75.75 0 0 1 .208 1.04l-5 7.5a.75.75 0 0 1-1.166.04l-2.5-2.5a.75.75 0 1 1 1.06-1.06l1.875 1.875 4.484-6.687a.75.75 0 0 1 1.04-.208Z"
        />
      </svg>
    </Headless.Checkbox>
  )
}

export function CheckboxField({ className, ...props }) {
  return (
    <Headless.Field data-slot="field" className={clsx(className, 'flex items-center gap-x-3')} {...props} />
  )
}

export function CheckboxGroup({ className, ...props }) {
  return (
    <div data-slot="control" className={clsx(className, 'space-y-3')} {...props} />
  )
}

export function Switch({ checked, onChange, className, ...props }) {
  return (
    <Headless.Switch
      checked={checked}
      onChange={onChange}
      className={clsx(
        className,
        'group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent',
        'transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2',
        checked ? 'bg-cyan-600' : 'bg-gray-200'
      )}
      {...props}
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className={clsx(
          'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0',
          'transition duration-200 ease-in-out',
          checked ? 'translate-x-5' : 'translate-x-0'
        )}
      />
    </Headless.Switch>
  )
}